import {React} from 'react';
import '../styles/Chateau.css'
import 'animate.css'
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react'

const texts = {
  section: {
    en: 'Château',
    fr: 'Le Château',
  },
  block1: {
    title: {
      en: ['History of', 'Château'],
      fr: ['L’historique', 'du Château'],
    },
    p1: {
      en: 'Château la Croix de Millorit is one of the oldest residences in the Côtes de Bourg, located on the best hillsides of the Bourgeois bordering the Gironde.',
      fr: 'Situé au bord de la Gironde sur les pittoresques collines du Bourgeais, figure le château La Croix de Millorit une des plus anciennes résidences des Côtes de Bourg.',
    },
    p2: {
      en: 'During the Revolution, the place belonged to the widow of Larroque. At that time it consisted of a house and several rooms for the accommodation of the master, room for the accommodation of the agent and peasant, cellar, vat room, courtyard and forecourt, garden.',
      fr: 'A la révolution, le lieu de « Millory » ou « La Croix » appartenait à la veuve de Larroque. Le lieu-dit « Millory » consistait alors en une maison et plusieurs chambres pour le logement du maître, chambre pour le logement de l’agent et paysan, chais, cuvier, cour et avant-cour et jardinet.',
    },
    p3: {
      en: 'In 1850, the property belonged to Henry Ribadieu, author of the book Les Châteaux de la Gironde (1856) and editor of the newspaper La Guienne. He produces 50 barrels of wine here. In the edition of the book Bordeaux and its wines in 1868, the property appears under the name `Millorit`.',
      fr: 'En 1850 le propriétaire en était Henry Ridabieu, auteur du livre « Les Châteaux de la Gironde (1856) » et rédacteur en chef du journal « La Guienne ». A cette époque il y produisait 50 tonneaux. Dans l’édition de l’ouvrage « Bordeaux et ses vins » publié en 1868, la propriété apparait pour la première fois sous le nom de « Millorit ».',
    },
    p4: {
      en: 'At the end of the 19th century, the Millorit estate belonged to the Monnier brothers. It comprised 22 hectares, including 20 hectares of vine; the vineyard was partly reconstituted following phylloxera with grape varieties grafted onto American plants.',
      fr: 'A la fin du 19 eme siècle, le domaine appartenait aux frères Monnier. Il comprenait 22 hectares dont 20 hectares de vignes. Le vignoble a été en partie reconstitué à la suite du phylloxéra avec des cépages greffés sur des plants américains. Ce renouvèlement s’vest probablement accompagné de la reconstruction des bâtiments, notamment du cuvier de type médocain.',
    },
    p5: {
      en: 'In 1898 wine production reached 100 barrels. The domain takes the name of "La Croix": according to the work of Cocks and Féret, "after having the name of Millorit for a few years, it was returned the title it has had for a century".',
      fr: 'En 1898, la production atteignait les 100 tonneaux. Dans l’ouvrage de Cocks et Féret le domaine est référencé sous le nom de « Lacroix ». Après avoir porté le nom de Millorit pendant quelques années, il a repris le titre qu’il portait au siècle dernier « La Croix de Millorit ». L’ouvrage précise qu’un tiers du vignoble est encore planté de vieilles vignes françaises.',
    },
  },
  block2: {
    title: {
      en: ['La Croix de Millorit', 'Today'],
      fr: ['La Croix de Millorit', 'de Nos Jours'],
    },
    p1: {
      en: 'Located on limestone hillsides, formerly exploited in building stone quarries, the estate has been selected by the municipality of Bayon for its beauty and its set of microclimates.',
      fr: 'De nos jours le domaine situé sur les collines calcaire de la commune de Bayon se constitue d’un manoir de belles proportions, de chais et de vignes d’une superficie de 19.4 hectares. Le vignoble produit 100 000 bouteilles par an.',
    },
    p2: {
      en: 'Today the property consists of historical mansion, traditional vineyard and wine cellar surrounded by 19.4 hectares of vines. Our vineyard produces approximately 100000 bottles a year.',
      fr: '',
    },
  }
}

const animate =(inView, animationType, delay, speed)=>{
  const animation = `animate__${animationType}`;
  const animateSpeed = speed ? `animate__${speed}` : '';
  return `animate__animated ${inView ? animation : ''} animate__delay-${delay}s ${animateSpeed}`;
}

const setSection =(section, props, inView)=>{
  if(inView && props.nav !== section){
    setTimeout(()=>{
      props.setNav(section);
    }, 500);
  }
}

const HistorySection =(props)=> {
  const section = 'chateau';
  const lang = props.lang;
  const { ref, inView } = useInView({threshold: 0.4});
  useEffect(() => {
    setSection(section, props, inView);
  });
  return (
    <div ref={ref}>
      <div className='section-title first'>
          <h2 className={animate(inView, 'bounceInDown', 0.2)}>{texts.section[lang]} </h2>
          <h3 className={animate(inView, 'flipInX', 1)}>
            <span>{texts.block1.title[lang][0]} </span><span>{texts.block1.title[lang][1]}</span>
          </h3>
          <p className={animate(inView, 'fadeIn', 1, 'slow')}>{texts.block1.p1[lang]}</p>
        </div>
        <div className={`row content ${animate(inView, 'fadeIn', 0, 'slow')}`}>
          <div className="col-lg-6">
            <p>{texts.block1.p2[lang]}</p>
            <p>{texts.block1.p3[lang]}</p>
          </div>
          <div className="col-lg-6 pt-4 pt-lg-0">
            <p>{texts.block1.p4[lang]}</p>
            <p>{texts.block1.p5[lang]}</p>
            <p>
            </p>
          </div>
        </div>
    </div>
  )
}

const TodaySection =(props)=> {
  const lang = props.lang;
  const { ref, inView } = useInView({threshold: 0.5});
  return(
    <div ref={ref}>
      <div className="section-title second" id="chateau2">
          <h3 className={animate(inView, 'flipInX', 1)}>{texts.block2.title[lang][0]} <span>{texts.block2.title[lang][1]}</span></h3>
          <p></p>
        </div>

        <div className={`row content ${animate(inView, 'fadeIn', 0, 'slow')}`}>
          <div className="col-lg-6">
            <p>
              <img src="/la-croix-de-millorit.jpg" className="chateaux-image" alt=""></img>
            </p>
          </div>
          <div className="col-lg-6 pt-4 pt-lg-0">
            <p>{texts.block2.p1[lang]}</p>
            <p>{texts.block2.p2[lang]}</p>
          </div>
        </div>
    </div>
  )
}

const Chateau =(props)=> {
    return (
    <section id="chateau" className="section chateau">
      <div className="container" >
        <HistorySection lang={props.lang} nav={props.nav} setNav={(section)=>{props.setNav(section)}}/>
        <TodaySection lang={props.lang} nav={props.nav} setNav={(section)=>{props.setNav(section)}}/>
      </div>
    </section>
    );
}

export default Chateau;